import { getCookie } from 'cookie'

/**
 * Parse mimic_token cookie (plain string or legacy j:{"token":"..."} form).
 * Mirrors papaya `parseMimicTokenCookie` in api/services/Mimic/mimicGuards.ts.
 */
export function parseMimicTokenCookie(raw: string | undefined | null): string | null {
  if (!raw) return null
  const trimmed = String(raw).trim()
  if (!trimmed) return null

  const jsonish = trimmed.startsWith('j:') ? trimmed.slice(2) : trimmed
  if (jsonish.startsWith('{')) {
    try {
      const parsed = JSON.parse(jsonish) as { token?: string }
      if (parsed?.token) return String(parsed.token)
    } catch {
      return null
    }
  }

  return trimmed
}

/** Read and parse the browser `mimic_token` cookie. */
export function getMimicTokenFromCookie(): string | null {
  return parseMimicTokenCookie(getCookie('mimic_token'))
}

/**
 * After unmimic, admin-grant sessions have no useful merchant cookies.
 * Prefer staff admin SPA (VITE_STAFF_ADMIN_URL); fall back to merchant /admin path.
 */
export function redirectAfterUnmimic(path = '/users'): void {
  window.intercomSettings = undefined
  const base = ((import.meta as any).env?.VITE_STAFF_ADMIN_URL || '').replace(/\/$/, '')
  if (base) {
    window.location.href = `${base}${path.startsWith('/') ? path : `/${path}`}`
    return
  }
  window.location.href = `${window.location.protocol}//${window.location.host}/admin${path.startsWith('/') ? path : `/${path}`}`
}
